export const POP_UPS = {
  GET_ACC: "get_acc",
  END_OF_DEMO: "end_of_demo",
  BTINF: "BTINF",
  UPGRADE_PLAN: "upgrade_plan",
  SEND_MAIL: "send_mail",
  FEATURE_UPGRADE: "feature_upgrade",
};
